import React, { useRef } from "react";
import { Camera, X } from "phosphor-react";
import QueueStyle from "../Styled/Queue.style";
import { InputWithLabelHelpers } from "./Shared";

export function ImagesInput({ value, setValue }) {
  const formRef = useRef();
  return (
    <form ref={formRef}>
      <InputWithLabelHelpers
        type="file"
        id="file"
        label={
          value?.length ? (
            <QueueStyle gap="10px" justifyContent="space-between">
              <>{value?.length} image(s) selected </>
              <Camera size={18} weight="thin" />
            </QueueStyle>
          ) : (
            <QueueStyle gap="10px" justifyContent="space-between">
              Upload images <Camera size={18} weight="thin" />
            </QueueStyle>
          )
        }
        onChange={(e) => {
          setValue(e);
          formRef.current.reset();
        }}
        title={Object.values(value)
          .map((image) => image?.fileName)
          .join(", ")}
        helpers={[]}
        multiple
        hidden
      />
    </form>
  );
}
